import { type AgentActivity, AgentStatus } from '@/data/Agent';

type AgentActivityDotType = { status: 'success' | 'danger' | 'warning' | 'info' | undefined; color?: string };
export const getAgentActivityDot = (agentActivity: AgentActivity): AgentActivityDotType => {
  switch (agentActivity) {
    case 'RECEIVING':
    case 'AVAILABLE_ON_DEMAND':
      return { status: 'success' };
    case 'IN_QUEUE_CALL':
    case 'DIRECT_CALL':
      return { status: 'danger' };
    case 'ON_BREAK':
      return { status: 'warning' };
    case 'WRAP_UP':
      return { status: 'info' };
    default:
      return { status: undefined };
  }
};

export function isAgentAvailable(status: AgentStatus | string): boolean {
  return [AgentStatus.AVAILABLE, AgentStatus.AVAILABLE_ON_DEMAND].includes(status as AgentStatus);
}
